import React, { Component } from "react";
import Navigation from "./Components/Navigation";
import Footer from "./Components/Footer";
import mainLogo from'./neurotoolkit.png';
import "./index.css";

class App extends Component {
  render() {
    return (
	<div>
	<Navigation/>
	<div className="content">
	<h2>About Us</h2>
	NeurologyToolKit is the project of two medical students who recognize the important role that evidence-based medicine plays in improving patient care. We believe that using the most accurate and relevant information improves patient assessments and leads to more informed decision making.
	<br/>
	<br/>
	During our medical training, we discovered that many useful neurologic patient assessments and decision aids were either not available online or existed in a format that was challenging to use in a clinical setting.
	<br/>
	<br/>
	Therefore, we built NeurologyToolKit to fulfill the educational and clinical need for a single website devoted to neurologic scores and calculators in an easy-to-use format. NeurologyToolKit is designed and maintained such that the scores are:
	<br/>
	<br/>
	<ul>
	<li>Presented in an interactive format that works well with both computers and mobile devices</li>
	<li>Offered as a printable PDF</li>
	<li>Accompanied by a description of the tool as well as citations of the original and supporting literature</li>
	<li>Attributed to the appropriate authors and copyright holders</li>
	<li>Always free and easily accessible</li>
	</ul>
	<br/>
	Please feel free to send us feedback and suggestions via our <a href="http://neurotoolkit.com/contact-us/">contact page</a>.
	<br/>
	<br/>
	</div>
	<Footer/>
	</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js